<template>
    <div class="panel">
        <Checkbox v-model="data.hasFerryAddons" density="compact">
            Has Ferry Addons
        </Checkbox>
        <Checkbox v-model="data.hasFlightBrandedFares" density="compact">
            Has Flight Branded Fares
        </Checkbox>
    </div>
</template>

<script lang="ts">
    import { defineComponent, PropType } from 'vue';
    import { FakeDataPreCheckout } from '../DevPanel.interfaces';
    import Checkbox from '@ui/components/FormV2/Fields/Checkbox/Checkbox.vue';

    export default defineComponent({
        name: 'PreCheckoutPanel',
        components: {
            Checkbox,
        },
        props: {
            data: {
                type: Object as PropType<FakeDataPreCheckout>,
                required: true,
            },
        },
    });
</script>

<style lang="scss">
    @forward './Panel.scss';
</style>
